<template>
  <v-container class="px-0 mx-0">
    <v-layout justify-end>
      <v-btn @click="exportExcel" width="180" :loading="loading" class=" light--text text-capitalize btn_fnt" color="primary"> <v-icon small class="me-2">mdi-export</v-icon>Export </v-btn>
    </v-layout>
    <div v-show="false">
      <v-data-table id="exportBlock" hide-default-footer :items-per-page="-1" :headers="headers" :items="blockList" class="elevation-1 "> </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { Utils } from "../../../utils/utils";
export default {
  props: {
    blockList: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      variables: {
        limit: 0,
        skip: 0,
      },
      headers: [
        {
          text: "Area",
          value: "area.nameEn",
        },
        { text: "Block", value: "block" },
      ],
    };
  },

  methods: {
    exportExcel() {
      this.loading = true;
      Utils.htmlToExcel("exportBlock", "Block", false);

      this.loading = false;
    },
  },
};
</script>
